export const Engine = ["Cummins", "MWM", "MAN", "Scania", "Outro"];